import React from "react";
import "./PrivacyPolicy.css";

const ShippingPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>Shipping & Delivery Policy</h1>
        <p className="effective-date">Effective Date: May 07, 2026</p>

        <p>
       We deliver products across India.
        </p>

        <section>
          <h2>Order Processing</h2>

          <p>
       Orders are usually processed within 1–3 business days.

          </p>
        </section>

        <section>
          <h2>Delivery Timeline</h2>

          <p>Estimated delivery times:</p>

          <ul>
            <li>Metro Cities: 3–5 business days</li>
            <li>Other Locations: 5–8 business days</li>
          </ul>

          <p>
            Delivery times may vary during:
          </p>

          <ul>
            <li>Festivals</li>
            <li>Public holidays</li>
            <li>Unexpected courier delays</li>
          </ul>
        </section>

        <section>
          <h2>Shipping Charges</h2>

          <p>
            Shipping charges, if any, are displayed during checkout before
            payment confirmation.
          </p>
        </section>

        <section>
          <h2>Tracking Orders</h2>

          <p>
            Customers will receive order tracking details via email or SMS
            after the order has been dispatched.
          </p>
        </section>

        <section>
          <h2>Delivery Issues</h2>

          <p>
            If your package is delayed, lost, or damaged during delivery,
            please contact our support team for assistance.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>

          <p>
            For shipping or delivery-related queries,
            contact us:
          </p>

          <div className="contact-box">
            <p>Email: support@sapra.com</p>
            <p>Phone: +91 9876543210</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ShippingPolicy;